import { createRoutine } from 'redux-saga-routines';

import {
  GET_FESTIVAL,
  GET_PERFORMANCES,
  GET_FESTIVAL_CONTACTS,
  SET_FESTIVAL,
  ADD_AND_UPDATE_FESTIVAL_CONTACTS,
  UPDATE_FESTIVAL_INFO,
  CLEAR_FESTIVAL_PRODUCTIONS,
  UPDATE_FESTIVAL,
  GET_COMPANIES,
  GET_FESTIVAL_DESCRIPTIONS,
  CREATE_FESTIVAL_DESCRIPTIONS,
  DELETE_FESTIVAL_DESCRIPTIONS,
  UPDATE_FESTIVAL_DESCRIPTIONS,
  GET_FESTIVAL_VENUES,
  UPDATE_FESTIVAL_VENUES,
  SET_INIT_PRODUCTIONS,
  GET_FESTIVAL_VIDEOS,
  GET_FESTIVAL_LS_VOD,
  ADD_FESTIVAL_VIDEO,
  UPDATE_FESTIVAL_VIDEO,
  DELETE_FESTIVAL_VIDEO,
  GET_FESTIVAL_IMAGES,
  GET_FESTIVAL_EMPLOYEES,
  GET_FESTIVAL_BANNER,
  GET_FESTIVAL_PRODUCTION_IMAGES,
  GET_FESTIVAL_PRODUCTION_VIDEOS,
  GET_FESTIVAL_SEARCH_PRODUCTIONS_LIST,
  GET_FESTIVAL_TRANSLATIONS,
  UPDATE_FESTIVAL_TRANSLATIONS,
  DELETE_FESTIVAL_TRANSLATIONS,
  SET_FESTIVAL_PRODUCTION_RENTAL_ACTION,
  UPDATE_RENTAL_INCLUDES_ACTION,
  GET_FESTIVAL_YOUNG_ARTIST_PROGRAM,
  DELETE_FESTIVAL_YOUNG_ARTIST_PROGRAM,
  CREATE_FESTIVAL_YOUNG_ARTIST_PROGRAM,
  GET_FESTIVAL_COMPANY,
  CREATE_FESTIVAL_COMPANY,
  DELETE_FESTIVAL_COMPANY,
  GET_ABOUT_FESTIVAL_VIDEO,
  GET_FESTIVAL_REVIEWS,
  GET_FESTIVAL_PRODUCTION_REVIEWS,
} from './constants';

export const getFestivalAction = createRoutine(GET_FESTIVAL);
export const getFestivalContactsAction = createRoutine(GET_FESTIVAL_CONTACTS);
export const getFestivalProductionsAction = createRoutine(GET_PERFORMANCES);
export const updateFestivalAction = createRoutine(UPDATE_FESTIVAL);
export const getCompaniesAction = createRoutine(GET_COMPANIES);
export const getFestivalDescriptionsAction = createRoutine(GET_FESTIVAL_DESCRIPTIONS);
export const createFestivalDescriptionAction = createRoutine(CREATE_FESTIVAL_DESCRIPTIONS);
export const deleteFestivalDescriptionAction = createRoutine(DELETE_FESTIVAL_DESCRIPTIONS);
export const updateFestivalDescriptionAction = createRoutine(UPDATE_FESTIVAL_DESCRIPTIONS);
export const updateFestivalInfoAction = createRoutine(UPDATE_FESTIVAL_INFO);
export const addAndUpdateFestivalContactsAction = createRoutine(ADD_AND_UPDATE_FESTIVAL_CONTACTS);
export const getFestivalVenuesAction = createRoutine(GET_FESTIVAL_VENUES);
export const updateFestivalVenueAction = createRoutine(UPDATE_FESTIVAL_VENUES);
export const getFestivalVideosAction = createRoutine(GET_FESTIVAL_VIDEOS);
export const getFestivalLSVodAction = createRoutine(GET_FESTIVAL_LS_VOD);
export const getFestivalBannerAction = createRoutine(GET_FESTIVAL_BANNER);
export const addFestivalVideoAction = createRoutine(ADD_FESTIVAL_VIDEO);
export const updateFestivalVideoAction = createRoutine(UPDATE_FESTIVAL_VIDEO);
export const getFestivalProductionImagesAction = createRoutine(GET_FESTIVAL_PRODUCTION_IMAGES);
export const getFestivalProductionVideosAction = createRoutine(GET_FESTIVAL_PRODUCTION_VIDEOS);
export const getFestivalImagesAction = createRoutine(GET_FESTIVAL_IMAGES);
export const getFestivalEmployeesAction = createRoutine(GET_FESTIVAL_EMPLOYEES);
export const getFestivalSearchProductionsAction = createRoutine(GET_FESTIVAL_SEARCH_PRODUCTIONS_LIST);
export const getFestivalTranslationsAction = createRoutine(GET_FESTIVAL_TRANSLATIONS);
export const updateFestivalTranslationsAction = createRoutine(UPDATE_FESTIVAL_TRANSLATIONS);
export const deleteFestivalTranslationsAction = createRoutine(DELETE_FESTIVAL_TRANSLATIONS);
export const setFestivalProductionRentalAction = createRoutine(SET_FESTIVAL_PRODUCTION_RENTAL_ACTION);
export const updateRentalIncludesAction = createRoutine(UPDATE_RENTAL_INCLUDES_ACTION);
export const getFestivalYoungArtistProgramAction = createRoutine(GET_FESTIVAL_YOUNG_ARTIST_PROGRAM);
export const deleteFestivalYoungArtistProgramAction = createRoutine(DELETE_FESTIVAL_YOUNG_ARTIST_PROGRAM);
export const createFestivalYoungArtistProgramAction = createRoutine(CREATE_FESTIVAL_YOUNG_ARTIST_PROGRAM);
export const getFestivalCompaniesAction = createRoutine(GET_FESTIVAL_COMPANY);
export const deleteFestivalCompanyAction = createRoutine(DELETE_FESTIVAL_COMPANY);
export const createFestivalCompanyAction = createRoutine(CREATE_FESTIVAL_COMPANY);
export const getAboutFestivalVideoAction = createRoutine(GET_ABOUT_FESTIVAL_VIDEO);
export const getFestivalReviewsAction = createRoutine(GET_FESTIVAL_REVIEWS);
export const getFestivalProductionReviewsAction = createRoutine(GET_FESTIVAL_PRODUCTION_REVIEWS);

export const setFestival = festival => ({
  type: SET_FESTIVAL,
  payload: festival,
});

export const setInitProductions = (data, query) => ({
  type: SET_INIT_PRODUCTIONS,
  payload: { data, query },
});

export const clearFestivalProductions = () => ({
  type: CLEAR_FESTIVAL_PRODUCTIONS,
  payload: {},
});

export function deleteFestivalVideoAction(id) {
  return {
    type: DELETE_FESTIVAL_VIDEO,
    payload: { id },
  };
}
